import React from "react";
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardFooter,
  MDBCardHeader,
  MDBRow,
  MDBTypography,
} from "mdb-react-ui-kit";

export const ConfirmRorCard = ({ task, onConfirmRor }) => {
  const AffiliationInfo = () => (
    <>
      <MDBTypography className="my-2">Affiliation text</MDBTypography>
      <MDBTypography variant="h5" className="fw-bolder text-start">
        {task.data?.affiliation}
      </MDBTypography>
      {task.data?.address && (
        <MDBTypography variant="body2" className="text-muted text-start mt-1">
          <span className="fw-bold">Address:</span> {task.data.address}
        </MDBTypography>
      )}
    </>
  );

  const location = [];
  if (task.data?.country) location.push(task.data.country);
  if (task.data?.city) location.push(task.data.city);
  const locationText = location.length > 0 ? location.join(", ") : null;

  return (
    <MDBCard className="mb-5">
      <MDBCardHeader>
        <AffiliationInfo />
      </MDBCardHeader>
      <MDBCardBody>
        <MDBTypography className="mb-3">Matched ROR record</MDBTypography>
        <MDBRow className="text-start">
          <MDBTypography variant="h5" className="fw-bolder">
            {task.data?.ror_name}
            {locationText && `, ${locationText}`}
          </MDBTypography>
          <div>
            <a
              href={task.data?.ror_id}
              target="_blank"
              rel="noreferrer"
              aria-label={`Link to ${task.data?.ror_name}`}
            >
              {task.data?.ror_id}
            </a>
          </div>
        </MDBRow>
      </MDBCardBody>
      <MDBCardFooter>
        <div className="d-flex justify-content-center">
          <MDBBtn
            onClick={() => onConfirmRor(true)}
            className="mx-2"
            color="success"
          >
            Confirm
          </MDBBtn>
          <MDBBtn
            onClick={() => onConfirmRor(false)}
            className="mx-2"
            color="danger"
          >
            False positive
          </MDBBtn>
        </div>
      </MDBCardFooter>
    </MDBCard>
  );
};
